<template>
  <v-hover v-slot="{ hover }" class="ma-2">
    <v-card class="grey lighten-5 ma-2" width="265px">
      <router-link
        class="nav-link p-3"
        :to="{
          name: 'singleCollection',
          params: {
            clientId: collectionCheck.client_id,
            collectionId: collectionCheck.id,
          },
        }"
        aria-label="View collections"
      >
        <v-img height="265px" width="265px" :src="collectionCheck.thumbnail">
          <v-expand-transition>
            <div
              v-if="hover"
              class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal white--text align-center justify-center pa-4"
              style="height: 100%"
            >
              <p class="photo-meta caption d-block clearfix">
                {{ collectionCheck.owner.name }}
                <v-list-item
                  v-show="isSharer"
                  light
                  class="p-0 m-0 clearfix caption"
                >
                  <v-list-item-content>
                    <v-list-item-title>Shared with</v-list-item-title>
                    <v-list-item-subtitle
                      v-for="client in collectionCheck.shared_with_clients"
                      :key="client.id"
                      class="caption photo-meta caption"
                    >
                      <span class="whitetext">{{ client.name }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </p>
            </div>
          </v-expand-transition>

          <template #placeholder>
            <v-row class="fill-height ma-0 p-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>

        <div
          class="image-details pa-2 d-flex justify-space-between align-center"
        >
          <span class="image-title pa-0">{{ collectionCheck.name }}</span>
        </div>
      </router-link>
      <ShareCollection
        :collection-id="collection.id"
        :index="index"
        :icon-mode="true"
      />
      <v-dialog v-model="dialog" :disabled="canDelete" light width="500">
        <template #activator="{ on }">
          <v-btn icon :disabled="canDelete" v-on="on">
            <v-icon :size="30">mdi-delete-outline</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Are you sure you want to delete {{ collectionCheck.name }}
          </v-card-title>

          <v-card-actions>
            <v-btn color="primary" text @click="dialog = false"> No </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteCollection"> Yes </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-hover>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import { COLLECTIONS_REMOVE_COLLECTION } from "@/store/actions.type";
import ApiService from "@/common/api.service";

export default {
  name: "CollectionImage",
  props: {
    collection: {
      type: Object,
      default() {
        return { id: "" };
      },
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    isSharer() {
      if (
        this.collectionCheck.shared_with_clients &&
        this.collectionCheck.shared_with_clients.length &&
        this.activeExpClient.id === this.collectionCheck.owner.id
      ) {
        return true;
      }
      return false;
    },
    canDelete() {
      if (
        this.activeExpClient.id === this.collectionCheck.owner.id ||
        this.currentUser.roles.includes("client-manager") === true
      ) {
        return false;
      }
      return true;
    },
    collectionCheck() {
      if (!this.collection) return { id: "", client_id: "", name: "" };
      return this.collection;
    },
    ...mapGetters(["currentUser", "activeExpClient"]),
  },

  methods: {
    deleteCollection() {
      const collectionId = this.collection.id;
      this.msg = ApiService.delete(`collections/${collectionId}`, {
        client_id: this.collection.client_id,
        collection_id: this.collection.id,
      }).then(() => {
        store.dispatch(COLLECTIONS_REMOVE_COLLECTION, {
          collection: this.collection,
        });
        this.dialog = false;
      });
    },
  },
};
</script>
